// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2LC1K","buttons":"PendingPaymentAlert_buttons__2Faly"};